query PracticeStatsQuery($studentId: ID!) {
  practiceStats(studentId: $studentId) {
    trackingEnabled
    trackingPausedAt
    lastPracticedAt
    currentWeek {
      weekStart
      totalMinutes
      sessionCount
      activeDays
    }
    weeklyHistory {
      weekStart
      totalMinutes
      sessionCount
      activeDays
    }
    textBreakdown {
      description
      totalMinutes
      lastPracticedAt
    }
  }
}
